import type { UserFragment } from "@/v2-backoffice-client/user/__types__/user.fragment"

/**
 * Narrows a selection to the users a status change would actually affect —
 * users already in the target status are skipped, so the count on the badge
 * is the number of users that will change rather than the number selected.
 */
export function getActionableUserIds(users: UserFragment[], code: number) {
  const o = { actionableIds: [] as number[], count: 0 }
  for (const user of users) {
    if (user.UserStatusCode === code) continue
    o.actionableIds.push(user.Id)
    o.count++
  }
  return o
}
